import Vue from "vue";
import Vuex from "vuex";
import bets from "./bets";
import personalRoom from "./personalRoom";
import matches from "./matches";
import popups from "./popups";
import pagination from "./pagination";
import authorization from "./authorization";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    bets,
    personalRoom,
    matches,
    popups,
    pagination,
    authorization
  },
  state: {
    csrftoken: Cookies.get("csrftoken"),
    // https://stackoverflow.com/questions/1091372/getting-the-clients-timezone-in-javascript
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    document: document
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js